import {call, put, select, takeLatest} from "redux-saga/effects";
import {apiSchedule} from "./api";
import {
  fetchScheduleAction,
  fetchScheduleActionDone,
  fetchScheduleActionFail,
} from "./actions";
import {PayloadAction} from "@reduxjs/toolkit";
import {selectStore} from "../../selector";
import {RootState} from "../../index";

function* getScheduleFlow({payload}: PayloadAction<any>): any {
  const {schedule: {schedule: dataState}}: RootState = yield select(selectStore)
  // if (dataState.success) {
  //   yield put(fetchScheduleActionDone(dataState.data));
  // } else {
    try {
      const data = yield call(apiSchedule, payload);
      if (data.data) {
        yield put(fetchScheduleActionDone(data.data));
      }
    } catch (e) {
      console.warn(e);
      yield put(fetchScheduleActionFail());
    }
  // }
}

export default function* LessonSaga() {
  yield takeLatest(fetchScheduleAction, getScheduleFlow);
}

